export const GENERAL_EXCEPTION = {
  DEFAULT: 'DEFAULT',
  VALIDATION: 'VALIDATION',
  NOT_FOUND: 'NOT_FOUND',
  UNAUTHORISED: 'UNAUTHORISED',
  INVALID_CAPTCHA: 'INVALID_CAPTCHA',
  LIMIT_EXCEEDED: 'LIMIT_EXCEEDED',
  UNSUPPORTED_TIER: 'UNSUPPORTED_TIER',
  ALREADY_EXISTS: 'ALREADY_EXISTS',
  UNVERIFIED_USER: 'UNVERIFIED_USER',
  UNVERIFIED_EMAIL_USER: 'UNVERIFIED_EMAIL_USER',
  ACCESS_DENIED: 'ACCESS_DENIED',
  VIRUS_DETECTED: 'VIRUS_DETECTED'
};

export const VALIDATION_EXCEPTION = {
  REQUIRED: 'required',
  FORMAT: 'format'
};

export const AUTH_EXCEPTION = {
  EMAIL_EXIST: 'EMAIL_EXIST',
  MOBILE_EXIST: 'MOBILE_EXIST',
  ATTEMPTS_EXCEEDED: 'ATTEMPTS_EXCEEDED',
  CODE_EXPIRED: 'CODE_EXPIRED',
  CODE_MISMATCH: 'CODE_MISMATCH',
  INVALID_LOGIN_CREDENTIALS: 'INVALID_LOGIN_CREDENTIALS',
  USER_NOT_FOUND: 'USER_NOT_FOUND',
  INCORRECT_CURRENT_PASSWORD: 'INCORRECT_CURRENT_PASSWORD',
  ACCOUNT_SUSPENDED: 'ACCOUNT_SUSPENDED'
};
